import { FormEvent, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { IBasicSession } from 'types/basicSession';
import { useHistory, useParams } from 'react-router-dom';
import EditSessionForm from './components/EditSessionForm';
import CircularProgress from '@mui/material/CircularProgress';
import { useSessionQuery, useUpdateSessionMutation } from 'hooks/sessions';

const EditSession = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isFetching, refetch, error } = useSessionQuery(id);
  const {
    mutateAsync: updateSession,
    isLoading: isUpdating,
    error: errorOnUpdate,
  } = useUpdateSessionMutation(id);

  const loading = isLoading || isFetching;

  const [editedSessionData, setEditedSessionData] = useState<IBasicSession | null>(null);

  useEffect(() => {
    if (!loading && data) {
      setEditedSessionData(data.data);
    }

    if (!isUpdating && errorOnUpdate) {
      alert('Error updating session');
    }
  }, [data, errorOnUpdate, isUpdating, loading]);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();

      if (!editedSessionData) return;
      const response = await updateSession(editedSessionData);
      if (response.data) {
        toast.success('Session updated successfully');
        history.push('/dashboard/list-session');
      }
    } catch (error) {
      toast.error('Error updating session');
    }
  };

  if (loading)
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={30} />
      </div>
    );

    if (error || !editedSessionData) return (
      <div>
        <p>Error fetching session data</p>
        <button
          type="button"
          onClick={() => refetch()}
          className="mt-4 btn btn-primary btn-block w-100 d-flex align-items-center justify-content-center"
        >
          Refetch
        </button>
      </div>
    );

  return (
    <div>
      <h3>Edit Session</h3>

        <div>
          <EditSessionForm
            isUpdating={isUpdating}
            handleSubmit={handleSubmit}
            editedSessionData={editedSessionData}
            setEditedSessionData={setEditedSessionData}
          />
        </div>
    </div>
  );
};

export default EditSession;
